import * as React from "react";

import { cn } from "@/lib/utils";

interface InputProps extends Omit<React.ComponentPropsWithRef<"input">, "size"> {
  size?: "xs" | "sm" | "md";
}

const Input = ({ className, type, size, ref, ...props }: InputProps) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground placeholder:text-xs focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        size === "xs" && "h-7 px-2 py-0.5 text-sm",
        size === "sm" && "h-8 px-2 py-1 text-sm",
        size === "md" && "h-10 px-3 py-2 text-base",
        className,
      )}
      ref={ref}
      {...props}
    />
  );
};
Input.displayName = "Input";

export { Input };
